/** Suffixe du nom des contacts WhatsApp : « Camille Moreau - P-PWRC ». Il sert aussi de mot à chercher. */
export const WA_CONTACT_SUFFIX = "P-PWRC";

/** Minuscules, sans accents ni séparateurs : « Hélène-M » devient « helenem ». */
function squash(s: string): string {
  return s
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, "");
}

function titleCase(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/** Un morceau d'adresse qui ressemble à un nom : deux lettres au moins, aucun chiffre. */
function nameToken(token: string): boolean {
  return /^\p{L}{2,}$/u.test(token);
}

/**
 * Nom de famille lu dans la partie locale de l'e-mail, null si elle ne commence pas par le prénom.
 * `camille.moreau@…` donne « Moreau ». Sans séparateur (`camillemoreau@…`), le reste n'est
 * retenu que s'il prolonge `knownLastName` (« Mo ») : sinon rien ne dit qu'il s'agit d'un nom.
 */
export function lastNameFromEmail(
  firstName: string,
  email: string,
  knownLastName?: string | null,
): string | null {
  const local = email.split("@");
  const first = squash(firstName);
  if (local.length !== 2 || !first) return null;

  const tokens = local[0].split(/[._-]+/).filter(Boolean);
  let joined = "";
  let used = 0;
  while (used < tokens.length && joined.length < first.length) joined += squash(tokens[used++]);

  if (joined === first) {
    const rest = tokens.slice(used);
    if (rest.length === 0 || !rest.every(nameToken)) return null;
    return rest.map(titleCase).join(" ");
  }

  const known = knownLastName ? squash(knownLastName) : "";
  const whole = squash(local[0]);
  if (known && whole.startsWith(first + known)) {
    const rest = whole.slice(first.length);
    return nameToken(rest) ? titleCase(rest) : null;
  }
  return null;
}

/** Champs du formulaire « Nouveau contact » de WhatsApp Web. */
export function contactFields(p: {
  firstName: string;
  lastName: string | null;
  email: string | null;
}): { firstName: string; lastName: string } {
  const firstName = p.firstName.trim();
  const known = p.lastName?.trim() || null;
  const fromEmail = p.email ? lastNameFromEmail(firstName, p.email.trim(), known) : null;
  // L'e-mail ne remplace le calendrier que s'il le complète : un nom complet différent reste le bon.
  const useEmail = fromEmail && (!known || squash(fromEmail).startsWith(squash(known)));
  const lastName = useEmail ? fromEmail : known;
  return {
    firstName,
    lastName: lastName ? `${lastName} - ${WA_CONTACT_SUFFIX}` : `- ${WA_CONTACT_SUFFIX}`,
  };
}
